import React from 'react';
import './PizzaSupplements.scss';
import FormattedPrice from './FormattedPrice';
import PizzaPart from './PizzaPart';

const PizzaSupplements = ({supplements, selectedSupplements, onSelect, removeSelectedSupplement}) => {
  const isSelected = (item) => {
    return selectedSupplements.some(i => i.menuItem.menu_item_id === item.menu_item_id);
  };

  const selectedItem = (item) => {
    return selectedSupplements.find(i => i.menuItem.menu_item_id === item.menu_item_id);
  };

  const onSupplementClick = (supplement, part) => {
    if (isSelected(supplement) && selectedItem(supplement).orderItem.pizza_item_part === part) {
      removeSelectedSupplement(supplement);
      return;
    }

    const newSupplement = Object.assign({}, supplement);
    newSupplement.pizza_item_part = part;
    onSelect(newSupplement);
  };

  return (
    <div className={ 'pizza-supplements' }>
      <div className={ 'list' }>
        {
          supplements.map(item => (
            <div
              className={ `supplement ${isSelected(item) ? 'selected' : ''}` }>
              <div
                className={ 'supplement-info' }
                onClick={ () => {
                  // if (isSelected(item)) {
                  //   removeSelectedSupplement(item);
                  // } else {
                  //   onSupplementClick(item, '1000000');
                  // }
                } }
              >
                <div className={ 'name' }>
                  {item.item_name}
                </div>

                {item.web_price > 0 && (
                  <div className={ 'item-price' }>
                    <FormattedPrice price={ item.web_price } />
                  </div>
                )}
              </div>

              <div className={ 'parts' }>
                {
                  ['1000000', '0100000', '0010000'].map(part => (
                    <div
                      className={ `part ${isSelected(item) && selectedItem(item).orderItem.pizza_item_part === part ? 'selected' : ''}` }
                      onClick={ () => {
                        onSupplementClick(item, part);
                      } }
                    >
                      <PizzaPart part={ part } />
                    </div>
                  ))
                }
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default PizzaSupplements;
